'use strict';

var RomSummaryResTypeChartAggregationFactory = function RomSummaryResTypeChartAggregationFactory(AbstractROMServiceAggregationFactory) {
  function RomSummaryResTypeChartAggregation() {
    AbstractROMServiceAggregationFactory.call(this, 'rom-summary-mode', ['res-type-thematic-chart']);
  }
  RomSummaryResTypeChartAggregation.prototype = Object.create(AbstractROMServiceAggregationFactory.prototype);
  RomSummaryResTypeChartAggregation.constructor = RomSummaryResTypeChartAggregation;
  RomSummaryResTypeChartAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType.indexOf(targetType) !== -1;
  };
  RomSummaryResTypeChartAggregation.prototype.aggregate = function (data) {
    var metricsKeys = ['group', 'individual'];
    return this.aggregateWithMetrics(data, metricsKeys);
  };
  return RomSummaryResTypeChartAggregation;
};
RomSummaryResTypeChartAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory'];
module.exports = RomSummaryResTypeChartAggregationFactory;